/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown>, time: NonNullable<unknown> }} Cook_Timer_ElsewhereInputs */

const en_cook_timer_elsewhere = /** @type {(inputs: Cook_Timer_ElsewhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.step} · ${i?.time}`)
};

const de_cook_timer_elsewhere = /** @type {(inputs: Cook_Timer_ElsewhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schritt ${i?.step} · ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Step {step} · {time}" |
*
* @param {Cook_Timer_ElsewhereInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_timer_elsewhere = /** @type {((inputs: Cook_Timer_ElsewhereInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Timer_ElsewhereInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_timer_elsewhere(inputs)
	return en_cook_timer_elsewhere(inputs)
});